var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-cbr-Logo-outer"},[(_vm.src)?_c('img',{class:['c-cbr-Logo-logo', _vm.positionClass, _vm.$style.logo],attrs:{"src":_vm.src,"alt":("Logo of " + _vm.identifier)},on:{"click":function($event){return _vm.goHome()}}}):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bc98c5e2","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/CbrLogo.vue
// module id = 172
// module chunks = 0